/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ========================================================================= */

var saveDict = {
  'search': 'ts',
  'pubsearch': 'ps',
  'used_price_min': 'upl',
  'used_price_max': 'uph',
  'new_price_min': 'npl',
  'new_price_max': 'nph',
  'amazon_price_min': 'apl',
  'amazon_price_max': 'aph',
  'trade_in_min': 'tpl',
  'trade_in_max': 'tph',
  'total_used_min': 'tul',
  'total_used_max': 'tuh',
  'total_new_min': 'tnl',
  'total_new_max': 'tnh',
  'sales_rank_min': 'srl',
  'sales_rank_max': 'srh',
  'publication_date_min': 'pdl',
  'publication_date_max': 'pdh'
};

function SelectText(element) {
    var doc = document,
        text = doc.getElementById(element),
        range, selection;
    if (doc.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(text);
        range.select();
    } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
    }
}

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        jQuery('#calculatorModal').on('show.bs.modal', function (event) {
          jQuery("#purchase_price").val("");
          jQuery("#freeform_listing_price").val("");
          jQuery("#price_25").html(" -- ");
          jQuery("#price_50").html(" -- ");
          jQuery("#price_100").html(" -- ");
          jQuery("#price_200").html(" -- ");
          jQuery("#price_300").html(" -- ");
          jQuery("#freeform_roi").html(" -- ");

          jQuery("#profit_25").html(" -- ");
          jQuery("#profit_50").html(" -- ");
          jQuery("#profit_100").html(" -- ");
          jQuery("#profit_200").html(" -- ");
          jQuery("#profit_300").html(" -- ");
          jQuery("#freeform_profit").html(" -- ");

          var button = jQuery(event.relatedTarget); // Button that triggered the modal
          var weight = parseInt(button.data('weight')); // Extract info from data-* attributes
          var title = button.data('title'); // Extract info from data-* attributes
          var usedprice = button.data('used-price'); // Extract info from data-* attributes
          var startingprice = parseFloat(usedprice) + 3.99;
          jQuery("#purchase_price").val(parseFloat(startingprice.toFixed(2)));

          // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
          // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
          var modal = jQuery(this);
          modal.find('.modal-body input#weight').val(weight);
          modal.find('.modal-body #weight_display').html(weight / 100);
          modal.find('.modal-body #book_title span').html(title.replace(/\"/g, ""));
        }).on('shown.bs.modal',function(){
          jQuery("#calculatorModal [data-toggle='popover']").popover({html:true});
          jQuery("#purchase_price").trigger('keyup').focus().select();
          jQuery("#freeform_listing_price").trigger('keyup');
        });

        jQuery('#saveSearchModal').on('show.bs.modal', function (event) {
          jQuery("#save_url").text("");

          parseFilters();

          var saveObjects = [];

          for (var key in queryObject) {
            var adjustedKey = saveDict[key];
            if (adjustedKey) {
              saveObjects.push(encodeURIComponent(adjustedKey + '=' + queryObject[key]));
            }
          }

          jQuery("#save_url").text('?' + saveObjects.join('&'));
        }).on('shown.bs.modal',function () {
          SelectText("save_full_url");
        });

        jQuery("#freeform_listing_price").keypress(function(e){
          //prevent letters and more than one decimal from being typed here
          // 46 is a period
          if (e.which !== 46 && (e.which < 48 || e.which > 57)) {
              return(false);
          }
          if (e.which === 46 && this.value.indexOf(".") !== -1) {
              return(false);   // only one decimal allowed
          }
        }).keyup(function(){
          if(jQuery(this).val() !== ""){
            var weight = parseFloat(parseFloat(jQuery("input#weight").val() / 100).toFixed(2)); // convert to pounds
            var purchase_price = jQuery("#purchase_price").val();
            var salesPrice = jQuery("#freeform_listing_price").val();
            var saleFees = 1.80 + (salesPrice * 0.15);

            var shippingPerPound = 0.3;
            var inboundShipping = shippingPerPound * weight;

            /* weight charge */
            if(weight <= 0.87){
              weightFee = 2.41;
            }else if(weight <= 1.87){
              weightFee = 4.18;
            }else{
              weightFee = 4.18 + (0.39 * (Math.ceil(weight - 1.87)));
              weightFee = parseFloat(weightFee.toFixed(2));
            }
            var costs = weightFee + saleFees + inboundShipping + parseFloat(purchase_price) ;

            var freeformProfit = salesPrice - costs;

            jQuery("#freeform_profit").html(freeformProfit.toFixed(2));
            jQuery("#freeform_roi").html((freeformProfit / parseFloat(purchase_price) * 100).toFixed(1));
            jQuery("#fees_freeform").attr("data-content","Selling Fees: $" + saleFees.toFixed(2) + "<br>Inbound Shipping: $"+inboundShipping.toFixed(2)+"<br>Fulfillment Fees: $"+parseFloat(weightFee).toFixed(2) + "<hr>Total Fees: $"+(saleFees+inboundShipping+parseFloat(weightFee)).toFixed(2));
           }else{
            jQuery("#freeform_profit").html(" -- ");
            jQuery("#freeform_roi").html(" -- ");
            jQuery("#fees_freeform").attr("data-content"," -- ");
          }
        });

        function calculateMarginPricing(margin){
          var marginMultiplier = margin / 100;
          var purchase_price = jQuery("#purchase_price").val();

          var weight = parseFloat(parseFloat(jQuery("#weight").val() / 100).toFixed(2)); // convert to pounds

          var flatSalesFee = 1.80;
          var shippingPerPound = 0.3;
          var inboundShipping = shippingPerPound * weight;

          /* weight charge */
          if(weight <= 0.87){
            weightFee = 2.41;
          }else if(weight <= 1.87){
            weightFee = 4.18;
          }else{
            weightFee = 4.18 + (0.39 * (Math.ceil(weight - 1.87)));
            weightFee = parseFloat(weightFee.toFixed(2));
          }

          var simpleTotal = (( parseFloat(purchase_price) * (marginMultiplier + 1) ));

          var adjustedtotal = (simpleTotal + flatSalesFee + weightFee + inboundShipping) / 0.85  ; // / .7 is equivalent to the salesprice fee and the .85 overhead
          var profit = parseFloat(purchase_price) * marginMultiplier;
          if(isNaN(adjustedtotal)){
            margin = margin.toString();
            jQuery("#price_"+margin).html(" -- ");
            jQuery("#profit_"+margin).html(" -- ");
            jQuery("#calculatorModal [data-toggle='popover']").each(function(){
              jQuery("#fees_"+margin).attr("data-content"," -- ");
            });
          }else{
            jQuery("#price_"+margin).html(adjustedtotal.toFixed(2));
            jQuery("#profit_"+margin).html(profit.toFixed(2));

            jQuery("#calculatorModal [data-toggle='popover']").each(function(){
              jQuery("#fees_"+margin).attr("data-content","Selling Fees: $" + ((adjustedtotal * .15) + 1.80).toFixed(2) + "<br>Inbound Shipping: $"+inboundShipping.toFixed(2)+"<br>Fulfillment Fees: $"+parseFloat(weightFee).toFixed(2)+"<hr>Total Fees: $"+(((adjustedtotal * .15) + 1.80)+inboundShipping+parseFloat(weightFee)).toFixed(2));
            });
          }
        }

        //Calculator JS
        jQuery("#purchase_price").keypress(function(e) {
          //prevent letters and more than one decimal from being typed here
          // 46 is a period
          if (e.which !== 46 && (e.which < 48 || e.which > 57)) {
              return(false);
          }
          if (e.which === 46 && this.value.indexOf(".") !== -1) {
              return(false);   // only one decimal allowed
          }
        }).keyup(function(){
          calculateMarginPricing(25);
          calculateMarginPricing(50);
          calculateMarginPricing(100);
          calculateMarginPricing(200);
          calculateMarginPricing(300);
          jQuery("#freeform_listing_price").trigger('keyup');
        });

        //Btn toggler handling
        $(".btn-toggle").click(function(){
          if($(this).hasClass('btn-green')){ return; }
          $(this).toggleClass('btn-secondary btn-green');
          $(this).siblings('button').toggleClass('btn-secondary btn-green');

          var url = $(this).data('url');
          var option = $(this).data('option');
          var value = $(this).data('value');

          $.get(url, {option: option,value: value}, function(data){
            $('#main_results_table').bootstrapTable('refresh');
          });
          if(option == 'smile'){
            $("#amazon_smile").val(value);
          }
          if(option == 'account'){
            $("input.amazon_url_options").toggleClass('active');
          }

        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        $('#user_login').attr( 'placeholder', 'USERNAME' );
        $('#user_pass').attr( 'placeholder', 'PASSWORD' );
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'fba': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

//Open the mobile navigation on click
jQuery("#mobile_nav_trigger_wrap").click(function(e){
  e.preventDefault();
  jQuery("#sitewrap").toggleClass('mobile_nav_open');
  jQuery(".header-mobile").toggleClass('mobile_nav_open');
});

var getUrlParameter = function getUrlParameter(sParam, def) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
  return def;
};
